import { render, staticRenderFns } from "./tip.vue?vue&type=template&id=2d655c5c&scoped=true&"
import script from "./tip.vue?vue&type=script&lang=js&"
export * from "./tip.vue?vue&type=script&lang=js&"
import style0 from "./tip.vue?vue&type=style&index=0&id=2d655c5c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d655c5c",
  null
  
)

export default component.exports